import { ICreditMemoPaymentLog } from '../../client/interfaces/client-credit-memo.interface';
import { OrderSalesInterface } from '../../order/interfaces/order-sales.interface';
import { IWarehouseGroup } from '../../shared';

export interface IInvoiceShippingAddress {
  addressLine1 ?:string;
  addressLine2 ?:string;
  state ?:string;
  city ?:string;
  zipCode ?:string;
  country ?:string;
  phone ?:string;
}

export interface IInvoiceClientProfileMode {
  title :string;
  mode :string;
  icon :string;
}

export interface IInvoice {
  id :number;
  client_id :number;
  created_at :Date;
  updated_at :Date;
  line_items :IInvoiceLineItem[];
  warehouse_group_id :number;
  credit_memo_payment_log ?:ICreditMemoPaymentLog[];
  sales_order ?:OrderSalesInterface;
  warehouse_group ?:IWarehouseGroup;
  order_status ?:string;
}

export interface IInvoiceLineItem {
  id :number;
  description :string;
  item_id :number;
  sku :string;
  product_name :string;
  is_kit :number;
  quantity :number;
  unit_price :number;
  net_total_amount :number;
  discount_amount :number;
  discount_amount_per_unit :number;
  markup_amount :number;
  markup_amount_per_unit :number;
  ordered_uom_id :number;
  order :number;
  location_stock ?:IInvoiceLineItemLocationStock;
}

export interface IInvoiceLineItemLocationStock {
  id :number;
  last_updated :string;
  qty_incoming :number;
  qty_onhand :number;
  qty_pending :number;
  rfq_id :number;
}

export interface IInvoicePackingDetails {
  invoiceId :number;
  billToDetails :string;
  shipToDetails :string;
  otherDetails :string;
}

export interface IInvoiceType {
  affects_the_inventory :boolean;
  apply_pricing_structure :boolean;
  createdAt :string;
  createdBy :number;
  deletedAt :number;
  deletedBy :number;
  drop_ship :boolean;
  id :number;
  include_in_sales_reports :boolean;
  label :string;
  locked :boolean;
  status_string :string;
  updatedAt :string;
  updatedBy :number;
  warehouseGroupId :number;
  autopay :boolean;
  autopayAfterDays :number;
  dueDateDays :number;
  paymentTerms :string;
  autoPushUpdatesToSalesOrder :boolean;
}
export enum EAdvanceSettingsOption {
  FREQUENCY = 'frequency',
  PAYMENT_TERM_TITLE = 'payment_term_title',
  DELIVERY_TYPE = 'delivery_type',
  TAGS = 'tags',
}

export enum EInvoiceStatus {
  ALL = 'ALL',
  ACTIVE = 'ACTIVE',
  DRAFT = 'DRAFT',
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
  ESTIMATE = 'ESTIMATE',
}

export enum EInvoiceApprovalStatus {
  APPROVED = 'APPROVED',
  DECLINED = 'DECLINED',
  APPROVAL_REQUIRED = 'APPROVAL_REQUIRED',
}

export enum EInvoiceSettingsDefault {
  FREQUENCY = 'one_time',
  PAYMENT_TERM = '100% Down',
  DELIVERY_TYPE = 'standard',
}

export enum EWarehouseDefaultGroup {
  DEFAULT = 1,
}

export enum EInvoicePaymentStatus {
  UNPAID = 0,
  FULLY_PAID = 1,
  PARTIALLY_PAID = 2,
  PENDING_PAYMENT = 3,
}

export enum EInvoiceCreatedFrom {
  B2BPORTAL = 'B2BPORTAL',
  LUMINOUS = 'LUMINOUS',
}

export enum ELineItemRowType {
  SUB_TOTAL = 'subtotal',
}

export enum EInvoiceDataType {
  EXPORT = 'EXPORT',
  VIEW = 'VIEW',
}

export enum EInvoiceCreateTiming {
  ORDER_RECEIVED = 'ORDER_RECEIVED',
  SHIPMENT_CREATED = 'SHIPMENT_CREATED',
  FULFILLMENT_ORDER_CREATED = 'FULFILLMENT_ORDER_CREATED',
  FIRST_SHIPMENT_FULL_AMOUNT = 'FIRST_SHIPMENT_FULL_AMOUNT',
}

export enum EInvoiceCreateTimingDescription {
  ORDER_RECEIVED = 'When Sales Order is received/created',
  SHIPMENT_CREATED = 'When a Shipment is created (multiple invoices possible)',
  FULFILLMENT_ORDER_CREATED = 'When Fulfillment Order is created',
  FIRST_SHIPMENT_FULL_AMOUNT  = 'When first Shipment is created invoice the full order amount',
}
